export default "__VITE_ASSET__MKPDZDSy__"